import type { QueryParamDropdownListT } from "components/Reusable/QueryParamDropdownFilter/helpers/useQueryParamDropdown";

function getSelectedCount(selected: QueryParamDropdownListT) {
  if (!selected) return 0;

  const array = Object.values(selected)
    .filter((_) => _!!)
    .flat();

  return array.length;
}

export default getSelectedCount;